import styled from 'styled-components';
import {layout} from '../../../package.json';

export const ContainerWarranty = styled.section`
 display: flex;
 flex-direction: column;
`

export const ContentWarranty = styled.div`
display:flex;
// flex-wrap:wrap;
flex-direction: column;
margin-top: 15px;
width: 100%;
max-width: 570px;
`

export const ButtonWarranty = styled.div` 
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2%;
    width: 100%;
    height: 100%;
    min-width: 330px;
    max-width: 340px;
    min-height: 60px;
    max-height: 60px;
    border: 2px solid #e2e2e2;
    border-radius: 15px;
    & + & {
        margin-top: 15px;
    }
    cursor: pointer;
    div {
      display: flex;
      justify-content: center;
      flex:1;
      span {
        font-size: 18px;
        line-height: 25px;
         & + span {
             margin-left: 15px;
         }
      }
    }
`

export const InfoWarranty = styled.div`
margin-top: 15px;
width: 100%;
button {
 cursor:pointer;
}
`
export const TotalsWarranty = styled.div`
width: 100%;
div {
display: flex;
align-items:center;
justify-content: space-between;
margin-top: 15px;
}
> span{
    font-size: 18px;
    font-weight: 700;
   }
`

export const TitleWarranty = styled.div`
width: 100%;
display:flex;
align-items:center;
justify-content: center;
span{
 font-size: 20px;
 font-weight: 700;
}
`

export const ContentGlobal = styled.div`
display:flex;

@media (max-width: ${layout.desktop}) {
    flex-direction: column-reverse;
    align-items: center;
}
`

export const ContentLeft = styled.div`
margin: 0 auto;
min-height: 358px;
@media (min-width: ${layout.desktop}) {
    margin-right: 15px;
}
`

export const ContentRight = styled.div`
 height: inherit;
 width: 100%;
 max-width: 550px;
 display:flex;
 align-items:flex-end;
 margin-bottom: 35px;
`